export const pizzaMenu = {
  de: {
    intro:
      "Unsere Pizzen entstehen aus handwerklich geführtem Teig, sorgfältig ausgewählten Zutaten und der Leidenschaft, klassische Pizza neu zu interpretieren. Wo immer möglich, arbeiten wir mit regionalen Erzeugern zusammen und ergänzen diese durch ausgewählte italienische Spezialitäten.",
    groups: [
      {
        title: "Unsere Klassiker",
        sub:
          "Die Klassiker sind die Grundlage jeder guten Pizzakarte. Vertraute Kombinationen, handwerklich umgesetzt und mit hochwertigen Zutaten verfeinert.",
        items: [
          {
            name: "Die Königliche",
            intro: "Unsere Interpretation der Margherita.",
            desc: "Tomatensauce · Mozzarella · hausgemachtes Pesto · Parmesan",
            tag: "Die Königin aller Pizzen.",
            diet: "veggie",
          },
          {
            name: "Die Klassische",
            desc: "Tomatensauce · Mozzarella · Salami · Parmesan",
            tag: "Vertraut. Ehrlich. Handwerklich.",
          },
          {
            name: "Die Spezielle",
            desc: "Tomatensauce · Mozzarella · Salami · Schinken · Champignons",
            tag: "Vertraut und doch besonders.",
          },
        ],
      },
      {
        title: "Unsere Spezialitäten",
        sub:
          "Hier wird es kreativ. Diese Pizzen erzählen Geschichten, verbinden regionale Einflüsse mit italienischem Handwerk und machen Tæste einzigartig.",
        items: [
          {
            name: "Die Feurige",
            desc: "Tomatensauce · Mozzarella · scharfe Salami · würzige Nduja-Creme · rote Zwiebeln · getrocknete Tomaten · Crunchy Chili",
            tag: "Unsere Liebeserklärung an die Schärfe.",
            spice: 2,
          },
          {
            name: "Die Würzige",
            desc: "Tomatensauce · Mozzarella · Salsiccia · glasierter Fenchel",
            tag: "Italien trifft Charakter.",
          },
          {
            name: "Die Goldene",
            intro: "Carbonara neu gedacht.",
            desc: "Mozzarella · knuspriger Guanciale · Pecorino · unsere hausgemachte Eigelbcreme",
            tag: "Cremig, intensiv und unglaublich aromatisch.",
          },
          {
            name: "Die Sanfte",
            desc: "Mozzarella · Mortadella · Stracciatellacreme · Pistaziencreme · Pistazienstücke",
            tag: "Eine Pizza, die Gäste fotografieren, bevor sie den ersten Bissen nehmen.",
          },
          {
            name: "Die Edle",
            desc: "Mozzarella · Gorgonzola-Creme · Birne · Walnüsse",
            tag: "Süß, salzig und elegant zugleich.",
            diet: "veggie",
          },
          {
            name: "Die Mediterrane",
            intro: "Knusprig gebackene Pizza mit sommerlichem Charakter.",
            desc: "Frische Bruschetta · Stracciatellacreme · Basilikum",
            tag: "Sommerlich. Mediterran. Frisch.",
            diet: "veggie",
          },
          {
            name: "Die Noble",
            desc: "Mozzarella · hauchdünne Kartoffeln · Ricotta-Creme · frischer Trüffel · Thymian",
            tag: "Eine außergewöhnliche Kombination mit besonderem Charakter.",
            diet: "veggie",
          },
          {
            name: "Die Bunte",
            desc: "Tomatensauce · gegrillte Zucchini · Aubergine · Paprika · hausgemachtes Pesto",
            tag: "Farbenfroh, frisch und voller Geschmack.",
            diet: "vegan",
          },
          {
            name: "Die Rustikale",
            desc: "Tomatensauce · geräucherter Tofu nach Gyros-Art · rote Zwiebeln · veganer Feta · vegane Aioli",
            tag: "Herzhaft. Würzig. Überraschend anders.",
            diet: "vegan",
          },
          {
            name: "Die Frische",
            desc: "Zucchini-Creme · Zucchinibänder · geröstete Artischockenherzen · Pinienkerne · Zitronenzeste · Basilikum",
            tag: "Leicht. Frisch. Mediterran.",
            diet: "vegan",
          },
          {
            name: "Die Festliche",
            intro: "Unsere Hommage an das traditionelle Lausitzer Hochzeitsessen.",
            desc: "Meerrettich-Schmand-Creme · Mozzarella · zartes Rindfleisch · Spreewaldgurken-Creme · frischer Schnittlauch",
            tag: "Frisch. Regional. Unverwechselbar.",
          },
          {
            name: "Die Verbotene",
            intro: "Die wohl umstrittenste Pizza der Welt, neu interpretiert.",
            desc: "Tomatensauce · Mozzarella · Kochschinken · hausgemachtes Ananasgel · Chili-Honig",
            tag: "Für alle, die glauben, Hawaii nicht zu mögen.",
            spice: 1,
          },
        ],
      },
      {
        title: "Saisonale Kreationen",
        sub:
          "Im Rhythmus der Jahreszeiten entstehen besondere Pizzen mit saisonalen Zutaten aus der Region.",
        items: [
          {
            name: "Die Frühlingswiese",
            desc: "Bärlauch-Mascarpone-Creme · grüner Spargel · Kochschinken · getrocknete Tomaten · Zitronenzeste",
            tag: "Der Frühling auf einer Pizza.",
          },
          {
            name: "Die Sommerfrische",
            desc: "Basilikum-Zitronenpesto · Mozzarella · Shrimps · Knoblauch · Zitronenzeste",
            tag: "Leicht, frisch und sommerlich.",
          },
          {
            name: "Die Herbstliche",
            desc: "Kürbiscreme · Scamorza · Kaminschinken · geröstete Kürbiskerne",
            tag: "Herbst auf einer Pizza.",
          },
        ],
      },
    ],
  },
  en: {
    intro:
      "Our pizzas are built on hand-led dough, carefully chosen ingredients and the passion to reinterpret a classic. Whenever possible we partner with regional producers and complement them with selected Italian specialities.",
    groups: [
      {
        title: "Our Classics",
        sub: "Familiar combinations, crafted by hand and refined with quality ingredients.",
        items: [
          { name: "Die Königliche", intro: "Our Margherita interpretation.", desc: "Tomato sauce · mozzarella · homemade pesto · parmesan", tag: "The queen of pizzas.", diet: "veggie" },
          { name: "Die Klassische", desc: "Tomato · mozzarella · salami · parmesan", tag: "Familiar. Honest. Hand-made." },
          { name: "Die Spezielle", desc: "Tomato · mozzarella · salami · ham · mushrooms", tag: "Familiar yet special." },
        ],
      },
      {
        title: "Our Specialties",
        sub: "Pizzas that tell stories, regional ingredients meet Italian craft.",
        items: [
          { name: "Die Feurige", desc: "Tomato · mozzarella · hot salami · nduja cream · red onions · dried tomatoes · crunchy chili", tag: "Our love letter to heat.", spice: 2 },
          { name: "Die Würzige", desc: "Tomato · mozzarella · salsiccia · glazed fennel", tag: "Italy meets character." },
          { name: "Die Goldene", intro: "Carbonara, rethought.", desc: "Mozzarella · crispy guanciale · pecorino · our homemade yolk cream", tag: "Creamy, intense and deeply aromatic." },
          { name: "Die Sanfte", desc: "Mozzarella · mortadella · stracciatella cream · pistachio cream · pistachio pieces", tag: "A pizza guests photograph before they bite." },
          { name: "Die Edle", desc: "Mozzarella · gorgonzola cream · pear · walnuts", tag: "Sweet, salty and elegant.", diet: "veggie" },
          { name: "Die Mediterrane", intro: "Crisp-baked pizza with a summery character.", desc: "Fresh bruschetta · stracciatella cream · basil", tag: "Summery. Mediterranean. Fresh.", diet: "veggie" },
          { name: "Die Noble", desc: "Mozzarella · thin potato slices · ricotta cream · fresh truffle · thyme", tag: "An exceptional combination with a distinctive character.", diet: "veggie" },
          { name: "Die Bunte", desc: "Tomato sauce · grilled zucchini · aubergine · peppers · homemade pesto", tag: "Colourful, fresh, full of flavour.", diet: "vegan" },
          { name: "Die Rustikale", desc: "Tomato sauce · smoked gyros-style tofu · red onions · vegan feta · vegan aioli", tag: "Hearty. Bold. Surprisingly different.", diet: "vegan" },
          { name: "Die Frische", desc: "Zucchini cream · zucchini ribbons · roasted artichoke hearts · pine nuts · lemon zest · basil", tag: "Light. Fresh. Mediterranean.", diet: "vegan" },
          { name: "Die Festliche", intro: "Our homage to the traditional Lausitz wedding meal.", desc: "Horseradish-sour-cream · mozzarella · tender beef · Spreewald cucumber cream · fresh chives", tag: "Fresh. Regional. Unmistakable." },
          { name: "Die Verbotene", intro: "The world's most controversial pizza, reinterpreted.", desc: "Tomato · mozzarella · cooked ham · homemade pineapple gel · chili honey", tag: "For everyone who thinks they don't like Hawaii.", spice: 1 },
        ],
      },
      {
        title: "Seasonal Creations",
        sub: "Special pizzas in the rhythm of the seasons, with regional ingredients.",
        items: [
          { name: "The Frühlingswiese", desc: "Wild garlic mascarpone · green asparagus · cooked ham · sun-dried tomatoes · lemon zest", tag: "Spring on a pizza." },
          { name: "The Sommerfrische", desc: "Basil-lemon pesto · mozzarella · shrimp · garlic · lemon zest", tag: "Light, fresh, summery." },
          { name: "The Herbstliche", desc: "Pumpkin cream · scamorza · smokehouse ham · toasted pumpkin seeds", tag: "Autumn on a pizza." },
        ],
      },
    ],
  },
};
